<template>
  <!-- eslint-disable -->
  <div
    :data-id="dataId"
    :id="'job-' + id"
    :class="{
      'has-logo': logo,
      'list-view': listview,
      'saved-view' : savedJobView || appliedJobView,
      priority: priority,
      preview: Boolean(pid === `P${this.page}-${this.id}`),
    }"
    @click="selectJobCard(id)"
    :data-cardid="`P${page}-${id}`"
    class="card cp-job-card has-logo"
  >
  <label v-if="miscellaneous.length" class="job-label">{{ miscellaneous[0] }}</label>
    <Bookmark
      v-if="!savedJobView && !appliedJobView"
      :id="String(id)"
      :source="bookmarkSource"
      :requestid="requestid"
      :class="{'list-view-bookmark-btn' : listview}"
      @save="saveBookmark"
      @unsave="unsaveBookmark"
    />
    <div v-if="savedJobView" class="saved-check-btn">
      <div class="form-check">
        <input
@change.prevent="selectedJob(id, false)"
          v-model="checked"
          :disabled="applied"
          type="checkbox"
class="form-check-input"
        >
      </div>
    </div>
    <div v-show="Number(score) > 70" :title="description" class="score">
      {{ Number(score) / 10 }}
      <div class="small">
        Match
      </div>
    </div>
    <div v-if="priority" class="priority priority-line" />
    <div v-if="!isBlind" :class="{'d-none' : savedJobView || appliedJobView}" class="cp-job-logo">
      <a
:href="companyLink()"
v-on:click="stopEvent"
target="_blank"
><img v-if="logo" :src="logo" :alt="company">
         <img v-else src="/asset/image/logo/color-blind.svg">
        </a>
    </div>
    <div v-else-if="isBlind" class="cp-job-logo">
      <img src="/asset/image/logo/color-blind.svg">
    </div>
    <div v-if="listview" :class="{ 'saved-flex' : savedJobView || appliedJobView}" class="list-view-col">
      <h5 :title="title" class="cp-job-title">
{{ title }}
</h5>
      <p v-if="isBlind" class="cp-job-company">
        <i>{{
          cpLang(
            "(This company has chosen not to disclose their company information. )"
          )
        }}</i>
        {{ company }}
      </p>

      <p v-else class="cp-job-company">
        <a :href="companyLink()" v-on:click="stopEvent" target="_blank">{{
          company
        }}</a>
      </p>
    </div>
    <div v-else>
      <h5 :title="title" class="cp-job-title">
{{ title }}
</h5>
      <p v-if="isBlind" class="cp-job-company">
        <i>{{
          cpLang(
            "(This company has chosen not to disclose their company information. )"
          )
        }}</i>
        {{ company }}
      </p>

      <p v-else class="cp-job-company">
        <a :href="companyLink()" v-on:click="stopEvent" target="_blank">{{
          company
        }}</a>
      </p>
    </div>
    <!-- <div v-if="priority && tag.length > 0" class="cp-job-tags">
        <div class="tags-wrapper">
        <label v-for="(item, index) in tag.slice(0,5)" :key="'tag-'+id+'-'+index" class="cp-job-tag">
          {{ item }}
        </label>
        </div>
      </div> -->

    <div v-if="!savedJobView && !appliedJobView" class="cp-job-info-block cp-job-info">
      <div v-if="industry" class="cp-info-item multiLine" title="Industry">
        <div class="bubble bg-cir_industry">
          <i class="cpi cpi-briefcase" />
        </div>
        <span>{{ cpLang(industry) }}</span>
      </div>
      <div v-if="cluster" class="cp-info-item multiLine" title="Cluster">
        <div class="bubble bg-cir_industry">
          <i class="cpi cpi-briefcase" />
        </div>
        <span>{{ cluster.default }}</span>
      </div>
      <div v-if="location" class="cp-info-item" title="Location">
        <div class="bubble bg-cir_location">
          <i class="cpi cpi-map-marker-alt" />
        </div>
        <span>
          {{ cpLang(location) }}
        </span>
      </div>
      <div v-if="activationdate" class="cp-info-item " title="Post Date">
        <div class="bubble bg-cir_date">
          <i class="cpi cpi-calendar-alt" />
        </div>
        <span>
          {{ toExpiryDate(activationdate.timestamp) }}
        </span>
      </div>
    </div>
    <div v-if="savedJobView || appliedJobView" class="saved-work-exp">
      {{ workExp }}
    </div>
    <div v-if="savedJobView" class="saved-exp-date">
      <span v-if="sort" :class="{'exp-text-danger': daygap <=3 }">{{ ch_expireDate }} </span>
      <span v-else>{{ workExp }}</span>
    </div>
    <div v-if="appliedJobView" class="saved-exp-date">
      <span v-if="sort">{{ toExpiryDate(applieddate.timestamp) }}</span>
      <span v-else>{{ workExp }}</span>
    </div>
    <div v-if="savedJobView" class="saved-action">
      <button class="btn btn-sm btn-default position-relative">
        <Bookmark
          :id="String(id)"
          :source="bookmarkSource"
          :requestid="requestid"
          :class="{'list-view-bookmark-btn' : listview}"
          :is-save-job-view="savedJobView"
          @save="saveBookmark"
          @unsave="unsaveBookmark"
        />
        <span>{{ cpLang('global.remove') }}</span>
      </button>
      <button :disabled="checked || applied" class="btn btn-sm btn-primary">
        <nuxt-link
          :to="{ path : `/myjob/apply/${id}` }"
          :disabled="checked"
          target="_blank"
          class="text-white"
          >
{{ applied ? cpLang('jd.applied') : cpLang('jd.apply') }}
</nuxt-link>
      </button>
    </div>
    <!-- <div v-if="appliedJobView" class="saved-action">
      <button @click.prevent="previewCv()" class="btn btn-sm btn-default">
Preview
</button>
    </div> -->
  </div>
</template>
<script>
import Bookmark from './Bookmark'
import commonFunc from '~/assets/js/commonHelper.js'

export default {
  components: {
    Bookmark
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    dataId: {
      type: String,
      default: ''
    },
    pid: {
      type: String,
      default: ''
    },
    requestid: {
      type: String,
      default: ''
    },
    page: {
      type: Number,
      default: 1
    },
    priority: {
      type: Number,
      default: 0
    },
    logo: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    applied: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: 'javascript:void(0)'
    },
    title: {
      type: String,
      default: ''
    },
    company: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    industry: {
      type: String,
      default: ''
    },
    cluster: {
      type: Object,
      default: () => ({})
    },
    joblevel: {
      type: String,
      default: ''
    },
    salary: {
      type: String,
      default: ''
    },
    miscellaneous: {
      type: Array,
      default: function() {
        return []
      }
    },
    filtered: {
      type: Boolean,
      default: false
    },
    employmenttype: {
      type: String,
      default: ''
    },
    activationdate: {
      type: Object,
      default: () => ({})
    },
    applieddate: {
      type: Object,
      default: () => ({})
    },
    workExp: {
      type: String,
      default: ''
    },
    expireDate: {
      type: Number,
      default: 0
    },
    minExperience: {
      type: String,
      default: ''
    },
    listview: {
      type: Boolean,
      default: false
    },
    savedJobView: {
      type: Boolean,
      default: false
    },
    cvid: {
      type: Number,
      default: 0
    },
    appliedJobView: {
      type: Boolean,
      default: false
    },
    tag: {
      type: Array,
      default: function() {
        return []
      }
    },
    score: {
      type: Number || String,
      default: function() {
        return null
      }
    },
    isBlind: {
      type: Boolean,
      default: false
    },
    sort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bookmarkSource: 'Job Card',
      ch_expireDate: '',
      checked: false,
      selectedAll: false,
      daygap: 0
    }
  },
  async mounted() {
    this.ch_expireDate = commonFunc.formatDate(await this.expireDate, 'M Y')
    this.daygap = commonFunc.calcDay(await this.expireDate)
    window.addEventListener('selectAllSavedJob', this.selectAll)
  },
  methods: {
    cardColor: function(i) {
      const colors = [
        'aqua',
        'black',
        'blue',
        'fuchsia',
        'gray',
        'green',
        'lime',
        'maroon',
        'navy',
        'olive',
        'orange',
        'purple',
        'red',
        'silver',
        'teal',
        'white',
        'yellow'
      ]
      return 'background-color:' + colors[i - 1] + ';'
    },
    stopEvent: function(event) {
      if (event) {
        event.stopPropagation()
      }
    },
    toExpiryDate(timestamp) {
      const now = Math.ceil(new Date().getTime() / 1000)
      const gap = now - timestamp
      if (gap < 60 * 60) {
        const time = Math.floor(gap / 60)
        const unit = time > 0 ? this.cpLang('global.mins_ago') : this.cpLang('global.min_ago')
        return time + ' ' + unit
      }
      if (gap < 60 * 60 * 24) {
        const time = Math.floor(gap / (60 * 60))
        const unit = time > 1 ? this.cpLang('global.hours_ago') : this.cpLang('global.hour_ago')
        return time + ' ' + unit
      }
      if (gap < 60 * 60 * 24 * 7) {
        const time = Math.floor(gap / (60 * 60 * 24))
        const unit = time > 1 ? this.cpLang('global.days_ago') : this.cpLang('global.day_ago')
        return time + ' ' + unit
      }
      if (gap < 60 * 60 * 24 * 9) {
        const time = 1
        const unit = this.cpLang('global.week_ago')
        return time + ' ' + unit
      }
      const date = new Date(timestamp * 1000)
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const month = 'recruitmentday.' + monthNames[date.getUTCMonth()].toLowerCase()
      return date.getDate() + ' ' + this.cpLang(month)
    },
    companyLink() {
      const slug = commonFunc.getSlug(this.company)
      return '/company-' + slug + '-jobs/1'
    },
    selectJobCard(id) {
      const slug = commonFunc.getSlug(this.title) + '-' + id
      const pid = `P${this.page}-${this.id}`
      const payload = { id: id, slug: slug, pid }
      // console.log('selectJobCard', payload)
      this.$emit('select', payload)
    },
    loadedHandle() {
      this.$emit('load')
    },
    saveBookmark(id) {
      this.$emit('save', id)
    },
    unsaveBookmark(id) {
      this.$emit('unsave', id)
    },
    selectedJob: function(id, all) {
      const event = new CustomEvent('selectedSavedJob', { detail: { id: id, all: all } })
      window.dispatchEvent(event)
    },
    selectAll: function() {
      if (this.savedJobView) {
        if (this.applied) {
          return false
        }
        if (!this.selectedAll) {
          this.checked = true
          this.selectedAll = true
          this.selectedJob(this.id, true)
        } else {
          this.checked = false
          this.selectedAll = false
          this.selectedJob(-1, false)
        }
      }
    },
    applyJob: function() {
      console.log('apply')
    },
    previewCv: function() {
      const event = new CustomEvent('previewResume', { detail: { id: this.cvid } })
      window.dispatchEvent(event)
    },
    removeJob: function() {
      console.log('remove')
    }
  }
}
</script>
